export default {
  0: { showImage: true },
  1: { showImage: true, showRubric: true },
  2: { showImage: true, showComments: true },
  3: { showImage: false, showTime: true },
  4: { showImage: true, showRubric: false },
  5: { showImage: true, desktopImageMaxWidth: 300 },
  6: { showImage: true, showRubric: false, imageHeight: 180, desktopImageMaxWidth: 350 },
};
